module.exports = __webpack_public_path__ + "img/HHaaldas2020b.f1a5f925.jpg";